import React, { useEffect, useState, useRef } from "react";
import _OrderRow from "./_OrderRow";
import { FaSearch } from "react-icons/fa";
import { useAppContext } from "../../../../../../Components/AppProvider";
import Modal from "../../../../../../PageCostumerProfile/PCPContents/Contents/Order History/Modal/Modal";
import ApproveDeclined from "../Modal/ApproveDeclined/ApproveDeclined";

function _Declined() {
  const [menuOpenId, setMenuOpenId] = useState(null);
  const [declinedOrder, setDeclinedOrder] = useState([]);
  const [updateDeclinedOrder, setUpdateDeclinedOrder] = useState(false);
  const { setCountListUpdate } = useAppContext();

  const [singleOrderToApprove, setSingleOrderToApprove] = useState(null);
  // ✅ search state
  const [searchTerm, setSearchTerm] = useState("");

  // ✅ keep track of selected orders
  const [selectedOrders, setSelectedOrders] = useState([]);

  // ✅ ref for select-all checkbox (to set indeterminate)
  const selectAllRef = useRef();

  useEffect(() => {
    let intervalId;

    async function fetchOrderContent() {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_BASE_URL}api/orders/get-declined-approval-order`,
          { credentials: "include" }
        );

        if (!res.ok) {
          console.error("HTTP error:", res.status);
          return;
        }

        const data = await res.json();
        if (Array.isArray(data.transactions)) {
          setDeclinedOrder(data.transactions);
          //console.log("data.declinedOrder :", data.transactions);
        } else {
          console.error("Invalid response:", data);
          setDeclinedOrder([]);
        }
      } catch (err) {
        console.error("Failed to fetch pending orders", err);
        setDeclinedOrder([]);
      }
    }

    fetchOrderContent(); // run immediately

    intervalId = setInterval(fetchOrderContent, 10000); // refresh every 10s

    return () => clearInterval(intervalId); // cleanup on unmount
  }, [updateDeclinedOrder]);

  // 🔹 Approve a single order
  // 🔹 Approve single transaction

  const handleApproveOrder = async (reason) => {
    if (singleOrderToApprove.length === 0) return;

    const confirmCancel = window.confirm(
      `Are you sure you want to cancel ${singleOrderToApprove.length} order(s)?`
    );
    if (!confirmCancel) return;

    try {
      const res = await fetch(
        `${process.env.REACT_APP_BASE_URL}api/orders/admin-cancel`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ orders: singleOrderToApprove, reason }),
        }
      );

      if (!res.ok) throw new Error("Failed to cancel order(s)");

      alert("Order(s) cancelled successfully!");

      // 🔹 Reset selection and refresh list
      setSelectedOrders([]);
      setSingleOrderToApprove(null); // ✅ clear it
      setCountListUpdate((prev) => !prev);
    } catch (err) {
      console.error(err);
      alert("Failed to cancel order(s). Please try again.");
    }
  };

  const handleRefundOrder = async (reason) => {
    let ordersToRefund = [];

    if (singleOrderToApprove) {
      // ✅ FIXED: use the right state
      ordersToRefund = [singleOrderToApprove];
    } else {
      ordersToRefund = filteredOrders.filter((order) =>
        selectedOrders.includes(order.COI_ID)
      );
    }

    if (ordersToRefund.length === 0) return;

    const confirmCancel = window.confirm(
      `Are you sure you want to cancel ${ordersToRefund.length} order(s)?`
    );
    if (!confirmCancel) return;

    try {
      const res = await fetch(
        `${process.env.REACT_APP_BASE_URL}api/orders/admin-cancel`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ orders: ordersToRefund, reason }),
        }
      );

      if (!res.ok) throw new Error("Failed to cancel order(s)");

      alert("Order(s) cancelled successfully!");

      // 🔹 Reset selection and refresh list
      setSelectedOrders([]);
      setSingleOrderToApprove(null); // ✅ clear it
      setCountListUpdate((prev) => !prev);
    } catch (err) {
      console.error(err);
      alert("Failed to cancel order(s). Please try again.");
    }
  };
  // bulk approve — selected Transactions (selectedOrders contains TransactionID)
  const handleApproveSelected = async () => {
    if (selectedOrders.length === 0) return;
    const ok = window.confirm(
      `Are you sure you want to approve ${selectedOrders.length} selected transaction(s)?`
    );
    if (!ok) return;
    //console.log("selectedOrders: ", selectedOrders);
    try {
      const payload = selectedOrders.flatMap((txId) => {
        const transaction = declinedOrder.find((t) => t.TransactionID === txId);
        if (!transaction) {
          console.warn("Transaction with ID not found:", txId);
          return [];
        }
        return transaction.OrderItems.map((item) => ({
          PT_ID: Number(transaction.TransactionID),
          COI_ID: Number(item.COI_ID),
          PD_ID: Number(item.PD_ID),
          status: item.Status,
          payment:
            item.Deposited != 0
              ? item.Balance
              : item.Status === "PartialApproval"
              ? item.Downpayment // or DownPayment field if exists
              : item.UnitPrice,
          quantity: Number(item.Quantity ?? 0),
        }));
      });

      if (payload.length === 0) {
        console.error("No valid transactions found for approval");
        return;
      }

      //console.log("Bulk approve payload:", payload);

      const res = await fetch(
        `${process.env.REACT_APP_BASE_URL}api/payments/approve-payment/bulk`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({ orders: payload }),
        }
      );

      if (res.ok) {
        console.log(`✅ Item(s) Successfully refunded.`);
        alert(`✅ Item(s) Successfully refunded.`);
        setUpdateDeclinedOrder((p) => !p);
        setCountListUpdate((p) => !p);
        setSelectedOrders([]);
      } else {
        console.error(
          "Failed to approve selected transactions",
          await res.text()
        );
      }
    } catch (err) {
      console.error("Error approving selected transactions:", err);
    }
  };
  // 🔹 Decline single transaction

  // 🔹 Decline multiple transactions
  const handleDeclineSelected = async () => {
    if (selectedOrders.length === 0) return;

    const ok = window.confirm(
      `Are you sure you want to mark as refund ${selectedOrders.length} selected transaction(s)?`
    );
    if (!ok) return;

    try {
      const payload = selectedOrders.flatMap((txId) => {
        const transaction = declinedOrder.find((t) => t.TransactionID === txId);
        if (!transaction) {
          console.warn("Transaction with ID not found:", txId);
          return [];
        }
        return transaction.OrderItems.map((item) => ({
          COI_ID: Number(item.COI_ID),
          PT_ID: Number(transaction.TransactionID),
        }));
      });

      if (payload.length === 0) {
        console.error("No valid transactions found for decline");
        return;
      }

      //console.log("Decline selected payload:", payload);

      const res = await fetch(
        `${process.env.REACT_APP_BASE_URL}api/payments/decline-payment/bulk`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({ paymentDecline: payload }),
        }
      );

      if (res.ok) {
        //console.log("Selected transactions declined:", payload);
        setUpdateDeclinedOrder((prev) => !prev);
        setCountListUpdate((prev) => !prev);
        setSelectedOrders([]); // ✅ clear selection
      } else {
        console.error(
          "Failed to decline selected transactions",
          await res.text()
        );
      }
    } catch (err) {
      console.error("Error declining selected transactions:", err);
    }
  };

  // ✅ filter orders based on search term
  const filteredOrders = declinedOrder.filter((order) => {
    const keyword = searchTerm.toLowerCase();

    const displayStatus =
      order.COI_Status === "PartialApproval"
        ? "For Approval (DP)"
        : order.COI_Status === "FullApproval"
        ? "For Approval (FP)"
        : order.COI_Status || "";

    return (
      order.PD_Name?.toLowerCase().includes(keyword) ||
      order.PO_Number?.toLowerCase().includes(keyword) ||
      `${order.CP_Firstname} ${order.CP_Lastname}`
        .toLowerCase()
        .includes(keyword) ||
      displayStatus.toLowerCase().includes(keyword)
    );
  });

  // ✅ handle toggle of one row
  const handleRowSelect = (txId) => {
    if (!txId) return; // safety check
    setSelectedOrders((prev) =>
      prev.includes(txId) ? prev.filter((id) => id !== txId) : [...prev, txId]
    );
  };
  // ✅ handle toggle all
  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedOrders(filteredOrders.map((o) => o.TransactionID)); // use TransactionID
    } else {
      setSelectedOrders([]);
    }
  };

  // ✅ check if all are selected
  const allSelected =
    filteredOrders.length > 0 &&
    filteredOrders.every((o) => selectedOrders.includes(o.TransactionID));

  // ✅ set indeterminate state
  useEffect(() => {
    if (selectAllRef.current) {
      selectAllRef.current.indeterminate =
        selectedOrders.length > 0 && !allSelected;
    }
  }, [selectedOrders, allSelected]);

  return (
    <>
      <main className="ad-order-panel-container">
        <div className="order-panel-header">
          <div className="order-panel-title-wrapper">
            <span>DECLINED PAYMENTS</span>
          </div>
          <div className="order-panel-actions-wrapper">
            {selectedOrders.length > 0 && (
              <>
                <button onClick={handleApproveSelected}>
                  APPROVE ({selectedOrders.length})
                </button>
              </>
            )}

            <div className="order-search-bar">
              <input
                type="text"
                placeholder="Keyword..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <span>
                <FaSearch />
              </span>
            </div>
          </div>
        </div>

        <div className="order-panel-table-wrapper">
          <table>
            <thead>
              <tr>
                <th></th>
                <th>TRANSACTION NUMBER</th>
                <th>CUSTOMER NAME</th>
                <th>NO. OF ITEMS</th>
                <th>DATE ORDERED</th>
                <th>PAYMENT METHOD</th>
                <th>PAYMENT TYPE</th>
                <th>AMOUNT PAID</th>
                <th>STATUS</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {filteredOrders.length > 0 ? (
                filteredOrders.map((transaction) => (
                  <_OrderRow
                    key={transaction.TransactionID}
                    transaction={transaction}
                    menuOpenId={menuOpenId}
                    setMenuOpenId={setMenuOpenId}
                    isSelected={selectedOrders.includes(
                      transaction.TransactionID
                    )}
                    onSelect={handleRowSelect} // <-- not wrapped
                    updateDeclinedOrder={updateDeclinedOrder}
                    setUpdateDeclinedOrder={setUpdateDeclinedOrder}
                    setCountListUpdate={setCountListUpdate}
                  />
                ))
              ) : (
                <tr>
                  <td
                    colSpan="11"
                    style={{ textAlign: "center", padding: "20px" }}
                  >
                    No results found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </main>
    </>
  );
}

export default _Declined;
